const ApplyOperation = {
    ACCEPT_OFFER: "accept_offer",
    APPLY: "apply",
    NONE: "none",
    PREQUALIFY: "prequalify",
    PRESCREEN: "prescreen",
}

export default ApplyOperation
